import { LOGIN, LOGOUT, UPDATE_USER } from "./type.action";
import RestUser from '../services/UserRestAPI';
import RestCompany from '../services/CompanyRestAPI';

// export const fireBaseLogin = (userData) => {
//   return (dispatch) => {
//     Firebase.getUsers().then((userArray) => {
//       let nameForm = userData.email;
//       let passForm = userData.password;
//       let exist = false;
//       for (const elem of userArray) {
//         if (elem.name == nameForm && elem.password == passForm) {
//           exist = true;
//         }
//       }
//       exist
//         ? dispatch({
//             type: FIRE_BASE_LOGIN,
//             payload: { auth: true, error: false },
//           })
//         : dispatch({
//             type: FIRE_BASE_LOGIN,
//             payload: { auth: false, error: true },
//           });
//     });
//   };
// };

export const logedIn = (userData) => {
  return (dispatch) => {
    // add company rbac rules
    RestCompany.getCompanyWithId(userData.companyId)
      .then(resp => {
        let companyRules = resp?.rules;
        dispatch({ type: LOGIN, payload: {...userData, companyRules} });
      });

  }; 
};

export const updateUser = (userData) => {
  return { type: UPDATE_USER, payload: userData };
};

export const logedOut = (_id) => {
  return (dispatch) => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    RestUser.logOut(_id)
      .then(res => {
        if (res)dispatch({ type: LOGOUT, payload: "" });
      });

  }; 
};
